import { useEffect } from 'react'
import type { NavigateFn } from '../types'

type UseSelfEnrollmentEntryEffectsArgs = {
  navigate: NavigateFn
  initialStep: number | null
  persistedCurrentStep: number
  setCurrentStep: (step: number) => void
  enrollmentSessionToken: string | null
}

export function useSelfEnrollmentEntryEffects({
  navigate,
  initialStep,
  persistedCurrentStep,
  setCurrentStep,
  enrollmentSessionToken
}: UseSelfEnrollmentEntryEffectsArgs) {
  useEffect(() => {
    if (initialStep !== null) {
      return
    }

    setCurrentStep(persistedCurrentStep)
  }, [persistedCurrentStep, initialStep, setCurrentStep])

  useEffect(() => {
    if (!enrollmentSessionToken) {
      navigate('/application', { replace: true })
    }
  }, [enrollmentSessionToken, navigate])
}
